import { useState, useEffect } from 'react'
import Api from 'services/api'

const useHehmTermsApi = () => {
  const [hehmTermsUpToDate, setHehmTermsUpToDate] = useState(false)
  const [isHehmTermsLoaded, setIsHehmTermsLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      setIsHehmTermsLoaded(false)

      try {
        const response = await Api.HomeHealth.getHehmTermsStatus()
        setHehmTermsUpToDate(response.hehmTermsUpToDate)
      } catch {
        setHehmTermsUpToDate(false)
      } finally {
        setIsHehmTermsLoaded(true)
      }
    })()
  }, [])

  return {
    hehmTermsUpToDate,
    isHehmTermsLoaded
  }
}

export default useHehmTermsApi
